import { create } from "zustand";
import { persist } from "zustand/middleware";

import { SURVEY_PREVIEW_MODE } from "@/constants/survey";
import type { SurveyPreviewMode } from "@/types/survey";

export type SurveyPreviewStoreState = {
  mode: SurveyPreviewMode;
  setMode: (mode: SurveyPreviewMode) => void;
};

export const useSurveyPreviewStore = create<SurveyPreviewStoreState>()(
  persist(
    (set) => {
      return {
        mode: SURVEY_PREVIEW_MODE.smart,

        setMode: (mode) => {
          set({ mode });
        },
      };
    },
    { name: "useSurveyPreviewStore" },
  ),
);
